module.exports = __webpack_public_path__ + "img/neck_width.fb782cf8.png";